var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailRead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#959da5"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M12 15.994c-.397 0-.794-.094-1.157-.283L.269 10.193a.501.501 0 01.463-.887l10.575 5.517a1.5 1.5 0 001.388 0L23.27 9.306a.5.5 0 01.463.887L13.157 15.71c-.363.189-.76.284-1.157.284z",
    "data-original": "#000000",
    transform: "matrix(.8 0 0 .8 2.4 2.42)"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M22 23H2c-1.103 0-2-.897-2-2V8.409c0-.748.412-1.427 1.075-1.773l10-5.218a2.002 2.002 0 011.85 0l10 5.218A1.994 1.994 0 0124 8.409V21c0 1.103-.897 2-2 2zM12 2.192c-.159 0-.318.038-.463.113l-10 5.218A.997.997 0 001 8.409V21c0 .551.449 1 1 1h20c.551 0 1-.449 1-1V8.409a.997.997 0 00-.537-.886l-10-5.218A.996.996 0 0012 2.192z",
    "data-original": "#000000",
    transform: "matrix(.8 0 0 .8 2.4 2.42)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailRead);
export default __webpack_public_path__ + "static/media/mail-read.e1f42e92f732fda257b805bcd0eac1e5.svg";
export { ForwardRef as ReactComponent };